import { render, staticRenderFns } from "./side-panel.vue?vue&type=template&id=1db96842&scoped=true&lang=pug"
import script from "./side-panel.vue?vue&type=script&lang=ts"
export * from "./side-panel.vue?vue&type=script&lang=ts"
import style0 from "./side-panel.vue?vue&type=style&index=0&id=1db96842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db96842",
  null
  
)

export default component.exports